import { Field } from 'formik'
import type { ReactNode } from 'react'
import React from 'react'

import { Fieldset, Input, Subsection } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import { TinyMCE } from '../../../../../../../../../components/adapters/inputs/TinyMCE'
import type { PostType } from '../../../../../../types'
import { PostTypeButtons } from '../../../../../Post/components/PostTypeButtons'
import type { FormValues } from '../../types'
import { TYPE_BUTTONS } from './consts'

type Props = {
  postTypeFieldName: string
  titleFieldName: string
  descriptionFieldName: string
  postType?: PostType
  subsectionTitle?: string
  disabled?: boolean
  children?: ReactNode
}

export const PostFields = ({
  postTypeFieldName,
  titleFieldName,
  descriptionFieldName,
  postType,
  subsectionTitle,
  disabled,
  children,
}: Props) => {
  const { setFieldValue } = useFormikContext<FormValues>()

  return (
    <Subsection title={subsectionTitle}>
      <Fieldset>
        <Fieldset.Row>
          <Fieldset.Item>
            <PostTypeButtons
              buttons={TYPE_BUTTONS}
              activeButton={postType}
              disabled={disabled}
              onClick={(type) => {
                setFieldValue(postTypeFieldName, type)
              }}
            />
          </Fieldset.Item>
        </Fieldset.Row>
        {children}
        <Fieldset.Row>
          <Fieldset.Item>
            <Field
              name={titleFieldName}
              component={Input}
              label="Post title"
              required
              fullWidth
              disabled={disabled}
            />
          </Fieldset.Item>
        </Fieldset.Row>
        <Fieldset.Row>
          <Fieldset.Item>
            <Field
              name={descriptionFieldName}
              component={TinyMCE}
              placeholder="Post description"
              disabled={disabled}
              resize
            />
          </Fieldset.Item>
        </Fieldset.Row>
      </Fieldset>
    </Subsection>
  )
}
